import { render, staticRenderFns } from "./PriceTableList.vue?vue&type=template&id=5c45211b&"
import script from "./PriceTableList.vue?vue&type=script&lang=js&"
export * from "./PriceTableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c45211b')) {
      api.createRecord('5c45211b', component.options)
    } else {
      api.reload('5c45211b', component.options)
    }
    module.hot.accept("./PriceTableList.vue?vue&type=template&id=5c45211b&", function () {
      api.rerender('5c45211b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/price-table/PriceTableList.vue"
export default component.exports